<template>
    <a-modal title="完善材料" :visible="visible" centered :destroy-on-close="true" :mask-closable="false"
             @cancel="onClose" :width="800">

<!--        <a-list size="small" :data-source="expertAdvise.adviseList[0].appendFiles.split(',')">
            <template #header>
                <div>上次补充文件列表</div>
            </template>
            <template #renderItem="{ item }">
                <a-list-item>
                    <div class="listItem">
                        <div>
                            <a target="_blank" :href="fileUrl+item" :title="item.split('|')[1]">
                                {{ item.split('|')[1] }}
                            </a>
                        </div>
                        <div>
                            <a target="_blank" :href="fileUrl+item">下载</a>
                        </div>
                    </div>
                </a-list-item>
            </template>
        </a-list>-->

<!--        <p v-for="(item, index) in expertAdvise.adviseList" :key="index">{{ item.expertName }}: {{ item.auditAdvise }}</p>-->
        <div v-if="expertAdvise.adviseList.length===0">
            <div style="background-color: rgb(248, 248, 248); font-size: 16px">
                <p style="color: #00cc00" v-if="reviewInfo.auditResult==='5'">通过待补充</p>
                <p style="color: #008000" v-if="reviewInfo.auditResult==='6'">已完成</p>
                <p style="color: #FF0000" v-if="reviewInfo.auditResult==='0'">未通过</p>
                <p>评审会议意见: {{ reviewResultAdvise }}</p>
            </div>
        </div>

        <a-timeline style="margin-top: 25px">
            <a-timeline-item v-for="item in expertAdvise.adviseList" :key="item.id">
                <div v-if="item.auditTime">
                    <div>{{ item.expertName }}<span style="margin-left: 20px">{{ item.auditTime }}</span></div>
                    <div style="background-color: rgb(248, 248, 248);">
                        <p style="color: #00cc00" v-if="item.auditResult===1">通过</p>
                        <p style="color: #ff0000" v-if="item.auditResult===0">驳回</p>
                        <p>{{ item.auditResult===1?"通过":"驳回" }}意见: {{ item.auditAdvise }}</p>
                    </div>
                </div>
                <div v-else>
                    <div>{{ item.expertName }}</div>
                    <div>
                        待处理
                    </div>
                </div>
            </a-timeline-item>
        </a-timeline>

        <a-alert type="warning" message="请上传完整版补充资料" show-icon style="width: 200px; margin: 20px 0"></a-alert>
        <FileUpload v-model:value="appendFileList" :names="'完善资料上传'" :multiple="true" :size="50" :count="5" :isPdf="true"></FileUpload>
        <template #footer>
            <a-button key="back" @click="onClose">关闭</a-button>
            <a-button key="submit" type="primary" :loading="confirmLoading" @click="onSubmit">提交</a-button>
        </template>
    </a-modal>
</template>

<script>
import {application, confirm} from "@/api/projectReviewService";

export default {
    name: "ImproveData",
    data(){
        return{
            visible:false,
            reviewId:undefined,
            reviewStatus:undefined,
            reviewResultAdvise:'',
            reviewInfo:[],
            confirmList:[],
            confirmLoading:false,
            expertAdvise:{
                adviseList:[]
            },
            appendFileList:[]
        }

    },
    watch:{
        visible(n){
            if (n){
                // this.getApplicationInfo()
                this.getConfirm()
            }
        }
    },
    methods:{
        getConfirm(){
            this.getAction({
                url: confirm.list,
                params:{
                    applicationId:this.reviewId
                }
            }).then(resp=>{
                this.expertAdvise.adviseList = resp
            })
        },
        onSubmit(){
            if (!this.appendFileList){
                this.$message.warning("请先上传需要完善的文件")
                return
            }
            this.postAction({
                url: application.appendAudit,
                params: {
                    applicationId: this.reviewId,
                    files: this.appendFileList
                }
            }).then(() => {
                this.onClose()
                this.$parent.loadData(1)
            })
        },
        onClose(){
            this.visible = false
        }

    }
}
</script>

<style scoped>
.listItem{
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    flex-wrap: nowrap;
    width: 100%;
}
</style>
